import React from 'react';
import { Block } from '@ffw/randstad-shared-components/build';
import UI from '@UI/hoc/UI';

export default UI(Block)();
